import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { get } from 'global/lib/lodash';
import { ListItem, ListItemText, ListItemSecondaryAction, Button, ListItemIcon } from '@mui/material';
import ReportsIcon from '@mui/icons-material/Assignment';
import Tooltip from '@mui/material/Tooltip';
import ReportsLockIcon from '@mui/icons-material/Lock';
import LotIcon from '@mui/icons-material/Home';
import { uppercaseFirst } from 'global/utils';
import TypoLabel from 'global/components/typo-label';
import { Loading } from 'global/styles';
import { CommunityIcon, DivisionIcon } from 'global/components/PerformIcons';
import ScoreIcon from 'global/components/ScoreIcon';
import useStyles from './ReportList.styles';
import { getRealmName } from 'global/utils';

const Location = ({ realm, realmType }) => {
  const classes = useStyles();
  return (
    <>
      {realmType === 'lot' ? (
        <LotIcon className={classes.icon} />
      ) : realmType === 'community' ? (
        <CommunityIcon className={classes.icon} />
      ) : realmType === 'division' ? (
        <DivisionIcon className={classes.icon} />
      ) : (
        <ReportsIcon className={classes.icon} />
      )}
      {uppercaseFirst(realm)}
    </>
  );
};

export default (props) => {
  const { item } = props;
  const classes = useStyles();
  const content = {
    ...item,
    title: get(item, 'name', Loading),
    realm: getRealmName(item),
    realmType: get(item, 'realm.tier', Loading),
    startDate: get(item, 'startDate', Loading),
    auditor: get(item, 'authors.0.email', '-unknown-'),
    scores: get(item, 'scores', Loading),
    status: get(item, 'status', Loading),
  };

  const getScoreNode = () => {
    if (content.status === 'draft') {
      return 'Draft';
    } else if (content.status === 'review') {
      return 'Under Review';
    } else {
      return <ScoreDisplay scores={content.scores ? content.scores : {}} id={content.id} />;
    }
  };

  return (
    <>
      <Tooltip title={get(item, 'locked') ? 'Locked by: ' + get(item, 'lockedBy.0.name') : ''} placement="right">
        <ListItem component={Link} to={`/reports/assessment/${content.id}`} classes={{ secondaryAction: classes.margRight }} button>
          <ListItemIcon className={classes.hideXSmall}>{get(item, 'locked') ? <ReportsLockIcon /> : <ReportsIcon />}</ListItemIcon>
          <ListItemText
            primary={content.title}
            secondaryTypographyProps={{ component: 'div' }}
            secondary={
              <>
                <TypoLabel hideSmallPrimary="true" primary={'Location: '} secondary={<Location realm={content.realm} realmType={content.realmType} />} />
                <TypoLabel hideSmallPrimary="true" primary={'Started: '} secondary={moment(content.startDate).format('MM/DD/YYYY')} />
                <TypoLabel hideSmallPrimary="true" primary={'Author: '} secondary={content.auditor} />
              </>
            }
          />
          <ListItemSecondaryAction className={classes.displayScores}>{getScoreNode()}</ListItemSecondaryAction>
        </ListItem>
      </Tooltip>
    </>
  );
};

const ScoreDisplay = ({ scores, id }) => {
  const classes = useStyles();
  return (
    <>
      {Object.keys(scores).map((scorecardId) => {
        const score = scores[scorecardId].calculatedScore;
        return (
          <Button className={classes.button} key={scorecardId} component={Link} to={`/reports/assessment/${id}/scores`}>
            <span className={classes.hideXSmall}>Score:&nbsp;</span>
            {`${scores[scorecardId].displayValue}`}
            <ScoreIcon score={score} />
          </Button>
        );
      })}
    </>
  );
};
